import { getField } from 'vuex-map-fields'
import { DEFAULT_FILTERS } from './teaminbox.store'

// Shared and frozen so an unsaved nav yields the same arrays each time, and watchers on them stay quiet
const NO_IDS = Object.freeze([])
const NO_ORDER = Object.freeze({})

export default {
  getField,

  // The user's saved pins, collapsed sections and per-section order, with defaults for a user who never saved
  inboxNav: (state, getters, rootState) => {
    const saved = rootState.auth.profile?.setting_inbox_nav || {}

    return {
      pinned_ids: saved.pinned_ids || NO_IDS,
      collapsed_sections: saved.collapsed_sections || NO_IDS,
      order: saved.order || NO_ORDER
    }
  },

  // True when any inbox filter is restricting results beyond the default view,
  // regardless of which entry point set it (quick-filter dropdown or full
  // filters panel). The default "Last 30 Days" window is the baseline, not a
  // user-applied filter, so it does not count — treating it as active would
  // push users toward "All Time", which is expensive to query for them and for
  // us. "All Time" (no date bound) is the widest possible view and never counts
  // either. Drives the active-filter badge on the filters icon and the
  // empty-state "clear filters to see more results" hint.
  hasActiveFilters: state => {
    const filters = state.activeFilters || {}

    // A bounded engagement-date window counts only when it differs from the
    // default "Last 30 Days" window.
    if (
      (filters.from_date || filters.to_date) &&
      filters.date_range !== DEFAULT_FILTERS.date_range
    ) {
      return true
    }

    if (
      filters.channels?.length ||
      filters.campaigns?.length ||
      filters.directions?.length ||
      filters.inboxes?.length
    ) {
      return true
    }

    return Boolean(
      filters.my_contact ||
      filters.unread_only ||
      filters.hide_opted_out ||
      filters.mention
    )
  },
  getNavListItems: state => [state.navListItems[0]],
  getInboxesFirstPage: state => state.inboxesFirstPage,
  getConnectedInboxesLength: state => state.inboxes.length,
  getInboxAnnouncementViewed: state => state.inboxAnnouncementViewed,
  getUnreadCountLoaded: state => state.unreadCountLoaded,

  // Check if team inboxes have been loaded (not currently loading)
  isTeamInboxesLoaded: state => {
    // We consider inboxes loaded when:
    // 1. We're not currently loading inboxes
    // 2. We've received a response (even if empty)
    return !state.isLoadingInboxes && state.inboxes !== null
  },

  // Check if user has any team inboxes attached
  hasTeamInboxes: state => {
    return state.inboxes && state.inboxes.length > 0
  },

  // Get the campaign ids for the active inbox
  activeInboxCampaignIds: state => state.activeInbox?.campaign_ids
    ? [...state.activeInbox.campaign_ids]
    : []
}
